import axiosAUTHAPI from "./axiosAUTHAPI";

// Auntheticate User
export const LoginUser = async (
    email, setEmail,
    password, setPassword,
    setIsUserAuntheticated,
    setAuntheticatedUser,
    setFetcherror,
    handleAllToasts,
    setLoader,
    t,
    LoadNotificationsCallBack
) => {
    const msg = t('Either Email or Password has not been provided');
    
    if (!email || !password) {
        handleAllToasts(2, msg); 
        return; 
    }

    const PushItem = {
        email,
        password
        };

    
  try {
      setLoader(true);
      const res = await axiosAUTHAPI.post("/userauth/", PushItem);
      const resdata = res ? res.data : {}
      setEmail("");
      setPassword("");
      setIsUserAuntheticated(true);
      setAuntheticatedUser(resdata?.user);
      localStorage.setItem('accessToken',resdata.accessToken);
      localStorage.setItem('refreshToken',resdata.refreshToken);
      handleAllToasts(1, "User Logged in Successfully");
      setLoader(false);
      LoadNotificationsCallBack(null, true);
    
    }
    catch(err){
        if(err?.response){
            console.log(err?.response);
            setFetcherror("Invalid Credentials");
            handleAllToasts(2, "Invalid Credentials"); 
            setLoader(false);
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("User not logged in");
            setLoader(false); 
        }
        
    }  
}

// export const RefreshToken = async () => {
    
//     try {
        
//         const refreshToken = document.cookie?.split('; ').find(row => row.startsWith('jwt=')).split('=')[1];

//         if (refreshToken) {
//             const res = await axiosAUTHAPI.post("/userauth/", { refreshToken });
//           const resdata = res ? res.data : {}
//           localStorage.setItem('accessToken', resdata.accessToken);
        

//           } else {
//             LogoutUser();
//           }
//     }
//     catch(err){
//         if(err.response){
//           console.log(err);
               
//         }else{
//             //No response Obtained from the server.
//             console.log(`Error: ${err.message}`);
          
            
//         }
        
//     }
    
// }

export const LogoutUser = async (
    
) => {
    
    try{
        // await axiosapi.post("/logout/");
        localStorage.removeItem('accessToken');
        
    
    }
    catch(err){
        if(err.response){
            console.log(err);
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
           
            
        }
        
    }
    
}

